import { getSiteMode } from '@wt/utilities/siteMode';
import { ReactNode } from 'react';

const HintButton = (props: {
  handleSelect: () => void;
  selected?: boolean;
  disabled?: boolean;
  children: ReactNode;
}) => {
  let style = {};
  let clazz =
    'select-none text-base rounded-lg outline flex-1 md:flex-initial min-w-[175px] max-w-[180px] text-center py-1 px-2 ';
  if (props.disabled) {
    clazz +=
      'outline-1 outline-accent bg-base-200 text-accent pointer-events-none opacity-30 ';
  } else if (props.selected) {
    clazz += 'outline-2 outline-accent bg-base-200 cursor-pointer ';
    if (getSiteMode() == 'whentaken-movies') {
      style = {
        boxShadow: '0px 0px 10px rgba(255, 194, 76, 0.5)',
      };
    } else {
      style = {
        filter: 'drop-shadow(0px 0px 3px rgba(106, 9, 246, 0.8))',
      };
    }
  } else {
    clazz +=
      'bg-[#5507C5] hover:bg-base-200 outline-1 outline-accent cursor-pointer ';
  }
  return (
    <div onClick={props.handleSelect} className={clazz} style={style}>
      {props.children}
    </div>
  );
};

export default HintButton;
